function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as styles from '../../styles/radio';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Radio = /*#__PURE__*/forwardRef((props, ref) => {
  var isTile = props.isTile,
    tileAppearance = props.tileAppearance,
    disabled = props.disabled;
  // props to pass to the input
  var radioProps = {
    defaultChecked: props.defaultChecked,
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onBlur: props.onBlur,
    onClick: props.onClick,
    onChange: props.onChange,
    onFocus: props.onFocus,
    value: props.value
  };

  // Don't set props.checked unless it's passed as a prop or
  // it becomes a controlled component
  if (props.checked !== undefined) {
    radioProps.checked = props.checked;
  }
  var labelClasses = classnames({
    'domain-radio__label': true,
    [props.className]: !!props.className,
    'is-disabled': disabled,
    isTile,
    'tile-segment': tileAppearance === 'segment'
  });
  var radioClasses = classnames({
    'domain-radio': true,
    'is-disabled': disabled
  });

  // The psuedo label element
  var labelText;
  if (props.labelContent) {
    labelText = ___EmotionJSX("span", {
      className: "domain-radio__label-text",
      css: styles.labelText({
        isTile,
        tileAppearance
      })
    }, props.labelContent);
  }
  return ___EmotionJSX("label", {
    className: labelClasses,
    css: styles.label({
      isDisabled: disabled,
      isTile,
      tileAppearance
    })
  }, ___EmotionJSX("input", _extends({
    type: "radio",
    className: "domain-radio__input"
  }, radioProps, {
    "aria-invalid": props.ariaInvalid,
    "aria-describedby": props.ariaDescribedBy,
    "aria-labelledby": props.ariaLabelledBy,
    css: styles.input,
    ref: ref
  })), !isTile && ___EmotionJSX("span", {
    className: "domain-radio__label-radio",
    css: styles.labelRadio
  }, ___EmotionJSX("span", {
    className: radioClasses,
    css: styles.radio(!!disabled)
  })), labelText);
});
Radio.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  labelContent: PropTypes.node,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  isTile: PropTypes.bool,
  tileAppearance: PropTypes.oneOf(['default', 'segment']),
  ariaInvalid: PropTypes.bool,
  ariaDescribedBy: PropTypes.string,
  ariaLabelledBy: PropTypes.string
};
Radio.defaultProps = {
  checked: undefined,
  className: undefined,
  defaultChecked: undefined,
  disabled: undefined,
  id: undefined,
  value: undefined,
  labelContent: undefined,
  isTile: false,
  tileAppearance: 'default',
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  ariaLabelledBy: undefined,
  onClick: () => {},
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {}
};
export default Radio;